import { useEffect, useState } from 'react';

import { IFile } from 'coreOld/types';

import FileUploadFormView from './FileUploadFormView';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  defaultValues?: IFile[];
  onSubmit?: (files: IFile[]) => void;
}

const FileUploadForm = ({ isOpen, onClose, title, defaultValues = [], onSubmit }: IProps) => {
  const [files, setFiles] = useState<IFile[]>([]);

  useEffect(() => {
    if (isOpen) {
      setFiles(defaultValues);
    }
  }, [defaultValues, isOpen]);

  const onFileDrop = (files: IFile[]) => setFiles(files);

  const onRemoveFile = (selectedFile: IFile) => {
    setFiles((prevFiles) =>
      prevFiles.filter((file: IFile) => {
        if (file?.path) {
          return file.path !== selectedFile.path;
        }

        return file.id !== selectedFile.id;
      })
    );
  };

  const handleOnSubmit = () => () => {
    onSubmit(files);
    onClose();
  };

  return (
    <FileUploadFormView
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      files={files}
      onFileDrop={onFileDrop}
      onRemoveFile={onRemoveFile}
      onSubmit={handleOnSubmit}
    />
  );
};

export default FileUploadForm;
